export default __webpack_public_path__ + "static/media/icon-random.993460ec.svg";